var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.btnList),function(item){return _c('el-button',{key:item.filed,on:{"click":function($event){return _vm.clickBtn(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }